import React from 'react';
import { House, ListNested, Building, PersonLinesFill, Youtube, Facebook, Instagram, Clock, Telephone, Envelope, Whatsapp } from 'react-bootstrap-icons';
import "./HorarioAtendimento.css";
import MudaPagina from "./Util/Navegacao.js";

const HorarioAtendimento = () => {
    return (
        <div className="horario-atendimento">
            <div className="conteudo">
                <ul className="infos">
                    <li className='desktop'><Clock size={14} color="#ff7b21"></Clock> Seg - Sex, das 7h às 17h</li>
                    <li className='link' onClick={() => MudaPagina("https://api.whatsapp.com/send?phone=5511950001834&text=Gostaria%20de%20mais%20informações.", "_blank")}><Whatsapp size={14} className='icone-redesocial'></Whatsapp> (11) 95000-1834</li>
                    <li className='link desktop' onClick={() => MudaPagina("mailto:vendas@construmarcas.com","_blank")}><Envelope size={14} className='icone-redesocial'></Envelope> vendas@construmarcas.com</li>
                </ul>
                <ul className="redes-sociais">
                    <li onClick={() => MudaPagina("https://www.facebook.com/construmarcas", "_blank")}><Facebook className='icone-rede-social' size={24} ></Facebook></li>
                    <li onClick={() => MudaPagina("https://www.instagram.com/construmarcas", "_blank")}><Instagram className='icone-rede-social' size={24} ></Instagram></li>
                    <li onClick={() => MudaPagina("https://www.youtube.com/channel/UC_RWM7QzzVqPtKAuxpJMmEg", "_blank")}><Youtube className='icone-rede-social' size={24} ></Youtube></li>
                </ul>
            </div>
        </div>
    )
}
export default HorarioAtendimento;